var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListInPersonMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3381_13333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3381_13333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16C4.09722 16 3.74653 15.8507 3.44792 15.5521C3.14931 15.2535 3 14.9028 3 14.5V5.5C3 5.0875 3.14931 4.73438 3.44792 4.44063C3.74653 4.14688 4.09722 4 4.5 4H13.5C13.9125 4 14.2656 4.14688 14.5594 4.44063C14.8531 4.73438 15 5.0875 15 5.5V9L17.3542 6.64583C17.4653 6.53472 17.6007 6.5081 17.7604 6.56598C17.9201 6.62384 18 6.73379 18 6.89583V13.1016C18 13.27 17.9201 13.3819 17.7604 13.4375C17.6007 13.4931 17.4653 13.4653 17.3542 13.3542L15 11V14.5C15 14.9028 14.8531 15.2535 14.5594 15.5521C14.2656 15.8507 13.9125 16 13.5 16H4.5ZM4.5 14.5H13.5V5.5H4.5V14.5Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListInPersonMeeting);
export default __webpack_public_path__ + "static/media/listInPersonMeeting.3dbc802d686305b9a8e3862b62d7aee4.svg";
export { ForwardRef as ReactComponent };